/*
 * Copyright (c) 2018-2023 MemberCenter, a subsidiary of Cameron Collective
 *   All Rights Reserved
 */
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import CssBaseline from '@mui/material/CssBaseline';
import Grid from '@mui/material/Grid';
import Toolbar from '@mui/material/Toolbar';
import { WEBSITE_URL } from 'config/app.config';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';

import { SignUpDescription, SignupForm } from './components';
import { styles } from './styles/signUpRoute.styles';

const SignUpRoute = () => {
	useEffect(() => {
		document.title = 'Member Center - Signup';

		window._hsq = window._hsq || [];
		const { _hsq } = window;

		_hsq.push(['setPath', '/signup']);
		_hsq.push(['trackPageView']);
	}, []);

	return (
		<>
			<AppBar elevation={0} sx={styles.header}>
				<CssBaseline />
				<Toolbar>
					<Link to={WEBSITE_URL}>
						<Box component="img" src="/signup-header.png" alt="Brand Logo" />
					</Link>
				</Toolbar>
			</AppBar>
			<Container component="main" maxWidth="lg">
				<Box sx={{ display: 'flex', alignItems: 'top', marginTop: '64px' }}>
					<Grid container spacing={2}>
						<Grid item xs={12} sx={{ margin: '-8px' }}>
							<SignUpDescription />
						</Grid>
					</Grid>
					<SignupForm />
				</Box>
			</Container>
		</>
	);
};

export default SignUpRoute;
